module.exports = __webpack_public_path__ + "static/media/IMG_8819.5b488332.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/horizontal/IMG_8819.jpg
// module id = 154
// module chunks = 0